import { render } from "./Basket.vue?vue&type=template&id=694614ff&scoped=true"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"

import "./Basket.vue?vue&type=style&index=0&id=694614ff&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3843889989/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694614ff"]])

export default __exports__